import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "suggest-container__list" }
const _hoisted_2 = ["onClick"]

import { i18n } from '@/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'Suggest',
  props: {
    value: {},
    minWidth: {},
    width: {},
    options: {}
  },
  emits: ["mouseover", "mouseleave", "clickSuggest"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "3de4fbee": (_ctx.minWidth ?? "64px"),
  "57abb4c0": (_ctx.width ?? "64px"),
  "3d9bbaa0": (_ctx.minWidth ?? "100%")
}))



const t = i18n.t;

const emits = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "suggest-container",
    class: "suggest-container",
    onMouseover: _cache[0] || (_cache[0] = ($event: any) => (emits('mouseover'))),
    onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (emits('mouseleave')))
  }, [
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (suggest, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: index,
          class: "suggest-container__item",
          onClick: ($event: any) => (emits('clickSuggest', suggest))
        }, [
          (suggest === 'UNSELECTED_HEADER_VALUE')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_unref(t)(suggest)), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(suggest), 1)
              ], 64))
        ], 8, _hoisted_2))
      }), 128))
    ])
  ], 32))
}
}

})